import { useDark, useToggle, useLocalStorage } from '@vueuse/core'

export function useTheme() {
  const isDark = useDark({
    selector: 'html',
    attribute: 'class',
    valueDark: 'dark',
    valueLight: '',
  })
  
  const toggleDark = useToggle(isDark)
  const theme = useLocalStorage('theme', 'dark')

  const toggleTheme = () => {
    toggleDark()
    theme.value = isDark.value ? 'dark' : 'light'
  }

  return {
    isDark,
    toggleTheme,
    theme
  }
}
